// Aftelling naar de bestelgrens (B28): op werkdagen voor de grens besteld, vandaag verzonden.
// Rekent in de tijd van Amsterdam, ongeacht waar de bezoeker is. Na de grens of in het weekend: wanneer de volgende verzending is.

const ZONE = 'Europe/Amsterdam';
const pad = (number) => String(number).padStart(2, '0');

class DispatchCountdown extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-text]');
    try {
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
    } catch {
      return;
    }
    this.cutoff = (Number(this.dataset.cutoff) || 12) * 3600;
    this.days = (this.dataset.days || '1,2,3,4,5').split(',').map(Number);
    this.closed = new Set((this.dataset.closed || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
    this.lang = document.documentElement.lang || 'en';
    this.clock = new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONE,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h23',
    });
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  now() {
    const parts = {};
    this.clock.formatToParts(new Date()).forEach((part) => (parts[part.type] = Number(part.value)));
    return {
      date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)),
      seconds: (parts.hour % 24) * 3600 + parts.minute * 60 + parts.second,
    };
  }

  ships(date) {
    return this.days.includes(date.getUTCDay()) && !this.closed.has(date.toISOString().slice(0, 10));
  }

  update() {
    if (document.hidden && this.rendered) return;
    const { date, seconds } = this.now();
    const left = this.cutoff - seconds;

    if (left > 0 && this.ships(date)) {
      const time = this.strings.time
        .replace('[h]', pad(Math.floor(left / 3600)))
        .replace('[m]', pad(Math.floor((left % 3600) / 60)))
        .replace('[s]', pad(left % 60));
      this.render(this.strings.countdown.replace('[time]', time), true);
      return;
    }

    for (let offset = 1; offset <= 31; offset++) {
      const next = new Date(date);
      next.setUTCDate(next.getUTCDate() + offset);
      if (!this.ships(next)) continue;
      if (offset === 1) {
        this.render(this.strings.tomorrow);
      } else {
        const options = { timeZone: 'UTC', weekday: 'long' };
        if (offset > 6) Object.assign(options, { day: 'numeric', month: 'long' });
        const day = new Intl.DateTimeFormat(this.lang, options).format(next);
        this.render(this.strings.later.replace('[day]', day));
      }
      return;
    }
  }

  render(text, html = false) {
    this.rendered = true;
    if (this.last === text) return;
    this.last = text;
    if (html) this.output.innerHTML = text;
    else this.output.textContent = text;
  }
}

if (!customElements.get('dispatch-countdown')) customElements.define('dispatch-countdown', DispatchCountdown);
